import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import React from "react";

const DataTableLoader = ({cols}) => {
  const items = Array.from({ length: 8 }, (v, i) => i)
  const colsArray = Array.from({ length: cols }, (v, i) => i)
  return (
    <div>
      <DataTable value={items} className="p-datatable-striped">
        {colsArray.map(col => (
          <Column
            header={<Skeleton width="4rem" />}
            style={{ width: "25%" }}
            body={<Skeleton />}
          ></Column>
        ))}
      </DataTable>
    </div>
  )
}

export default DataTableLoader
